<template>
    <div class="ur-radio-wrapper" :class="wrapperClass" >
        <!--
            $ver:v0.1.1
            여러 <em>ur-radio</em> 컴포넌트를 하나로 묶기 위한 영역입니다.
            #An area for grouping multiple <em>ur-radio</em> components into one.
        -->
        <slot>
            <ur-radio v-for="(radio, i) in items"
                        :key="i"
                        :size="radio.size"
                        :disabled="radio.disabled"
                        :iconType="radio.iconType"
                        :value="radio.value"
                        v-model="checked"
                        >{{radio.text}}</ur-radio>
        </slot>
        <div v-if="messageShow" :style="$_messageStyle()"
             class="ur-radio-wrapper__message ur-validator__message">{{messageShow}}</div>
    </div>
</template>
<script>
import urValidatorMixin from '../../../mixins/urValidator/urValidatorMixin.vue';
//ur-radio-wrapper는 다수의 Radio버튼을 감싸 하나의 세트로 동작하도록 지원하기 위한 컴포넌트 입니다.
//#ur-radio-wrapper is used to wrap multiple radio components to work like a set.
export default {
    name: 'ur-radio-wrapper',
    mixins: [urValidatorMixin],
    model: {
        prop: 'checked'
    },
    inject: {
        urInput: {from:'urInput', default: () => undefined}
    },
    props: {
        // $ver: v0.1.1
        // $v-model
        // v-model로 바인딩 되는 값입니다. <em>ur-radio-wrapper</em>하위에 존재하는
        // <em>ur-radio</em>의 v-model을 덮어씁니다.(단, group이 다른 경우 제외)
        // #The value bound to v-model. Overrides the v-model of <em>ur-radio</em> underneath <em>ur-radio-wrapper</em> (unless group is different)
        checked: {type: [Boolean, String]},
        // $ver: v0.2.0
        // <em>ur-radio-wrapper</em>하위에 items의 정보를 바탕으로  <em>ur-radio</em>을 생성합니다. 과 함께 쓰일 경우 <em>slot</em>이 우선순위를 갖습니다.
        // #Under the <em>ur-radio-wrapper</em>, create a <em>ur-radio</em> based on the information of that property. When used with <em>slot</em>, <em>slot</em> have priority.
        items: {type: Array, Object},
        // $ver: v0.1.1
        // 하단에 표시되는 가이드 메시지입니다. 별도의 설정이 없다면 출력되지 않습니다.
        // <em>ur-radio-wrapper</em>는 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
        // 메시지 출력을 원할 경우 공간확보가 필요합니다.
        // #The guide message that appears at the bottom. If there is no setting, no output.
        // #<em>ur-radio-wrapper</em> does not occupy space for message output.
        // #If you want to output a message, you need to make space.
        guideMessage: {type:String, default: undefined},
        // $ver: v0.1.1
        // validate를 통과한 경우 출력되는 메시지입니다.
        // 별도설정이 없다면 가이드 메시지가 출력되거나 아무런 메시지도 출력되지 않습니다.
        // <em>ur-radio-wrapper</em>는 메시지 출력을 위한 공간을 별도로 점유하지않습니다.
        // 메시지 출력을 원할 경우 공간확보가 필요합니다.
        // #The message that is output if validate passes.
        // #If there is no setting, guide message or no message is printed.
        // #<em>ur-radio-wrapper</em> does not occupy space for message output.
        // #If you want to output a message, you need to make space.
        successMessage: {type:String, default: undefined},
        // $ver: v0.1.1
        // <em>ur-radio-wrapper</em>하위에 존재하는 <em>ur-radio</em>중에서
        // <em>ur-radio-wrapper</em>와 group 이 같게 설정된 <em>ur-radio</em>만 영향을 받게됩니다.
        // wrapper와 radio모두 기본값은 'default'로 설정되어있습니다.
        // #<em>ur-radio-wrapper</em> below <em>ur-radio</em>,
        // #Only <em>ur-radio</em> with the same <em>ur-radio-wrapper</em> and group will be affected.
        // #Both wrapper and radio are set to 'default' by default.
        group: {
            type: String,
            default: 'default'
        },
        // $ver: v0.1.2
        // <em>ur-radio-wrapper</em>하위에 존재하는 <em>ur-radio</em>를 disabled 상태로 설정합니다.
        // <em>ur-radio-wrapper</em>와 group 이 같게 설정된 <em>ur-radio</em>만 영향을 받게됩니다.
        // #<em>ur-radio-wrapper</em> Set the <em>ur-radio</em> underneath to the disabled state.
        // #Only <em>ur-radio</em> with the same <em>ur-radio-wrapper</em> and group will be affected.
        // $default: false
        disabled: {
            type: Boolean,
            default: false
        },
        // $ver: v0.2.0
        // 하위 <em>ur-radio</em>의 크기를 결정합니다. 'small', 'medium' 두 가지 중 하나를 입력해야 합니다.
        // #The size You must enter one of two types: small or medium.
        size:  {type: String,
          validator: function (value) {
            return ['medium','small'].indexOf(value) !== -1;
          },
          default: undefined},
        // $ver: v0.1.2
        // 하위 <em>ur-radio</em>의 크기를 medium으로 정의합니다.
        // #Defines the size of the child <em>ur-radio</em> as medium.
        // $default: false
        medium: {
            type: Boolean,
            default: false
        },
        // $ver: v0.1.2
        // $abbr: medium
        md: {
            type:Boolean,
            default: false,
        },
        // $ver: v0.1.2
        // 하위 <em>ur-radio</em>의 크기를 small로 정의합니다.
        // #Define the size of the child <em>ur-radio</em> as small.
        // $default: false
        small: {
            type: Boolean,
            default: false
        },
        // $ver: v0.1.2
        // $abbr: small
        sm: {
            type:Boolean,
            default: false,
        },

        /* [FROM VALIDATOR] */
        // rules
        // disabled
        // lazy
        // noShake
        /********************/
    },
    data() {return {
        default: {
            size: 'medium'
        }
        /* [FROM VALIDATOR] */
        // hasError
        // errorMessage
        // showValid
        // shake
        /********************/

    }},
    computed: {
        $_size() {
            if(this.size ==='medium'|| this.medium || this.md) {return 'medium'}
            if(this.size ==='small'|| this.small || this.sm) {return 'small'}
            if(this.urInput) {return this.urInput.size}
            return this.default.size;
        },
        wrapperClass() { return {
            'ur-validator--error': this.hasError === true,
            'ur-validator--valid': this.showValid && this.hasError === false,
            'ur-validator--shake': this.shake
        }},
        /* [FROM VALIDATOR] */
        // isValidatable
        // el
        validateTarget() {return this.checked;}, // validation setting
        /********************/

        sharedData() {
            let rtn = {}, odf = Object.defineProperty;
            odf(rtn, 'checked' , {get:()=>this.checked});
            odf(rtn, 'emit' , {get:()=>this.emit});
            odf(rtn, 'click' , {get:()=>this.click});
            odf(rtn, 'disabled' , {get:()=>this.disabled});
            odf(rtn, 'hasError' , {get:()=>this.hasError});
            return rtn;
        },
        messageShow() {
            if(this.hasError === undefined) {
                return this.guideMessage;
            }
            if(this.hasError === true) {
                return this.errorMessage;
            }
            if(this.hasError === false) {
                return this.successMessage || this.guideMessage;
            }
            return undefined;
        }
    },
    watch: {
        validateTarget(val) {
            this.validateOnEvent(); // whenever checked value changes, execute validate() if lazy is false
        },

        successMessage: {
            immediate: true,
            handler(val) {
                this.showValid = !!val;
            }
        }
    },
    provide() {
        let rtn = {urRadioWrapper:{}}, odf= Object.defineProperty;
        rtn.urRadioWrapper[this.group] = this.sharedData;
        let urInput = {};
        odf(urInput, 'size', {get: ()=>this.$_size});
        rtn['urInput'] = urInput;
        return rtn;
    },
    methods: {
        /* [FROM VALIDATOR] */
        // validate()        --+
        // isValid()         --+-- exposed methods for manual validate control
        // clearValidation() --+
        // validateOnEvent() -> should be set by each component which uses urValidatorMixin
        /********************/

        emit(val) {
            // $ver: v0.1.1
            // $arg: updated v-model value
            // v-model에 설정된값(checked)을 업데이트합니다.
            // # update v-model value(checked props).
            this.$emit('input',val);
        },
        click(e){
            // $ver: v0.1.2
            // $arg: click event
            // click 시 이벤트를 호출합니다.
            // # Call event on click.
            this.$emit('click',e);
        }
    }
}

</script>
